import {Component, Input} from "@angular/core";
import {
    ITCIMediaAsset,
    TCI_MEDIA_DISPLAY_MODE,
    TCIMediaDisplaySize
} from "@tci/common";

@Component({
    selector: "ng-media",
    templateUrl: "./ng-upload.component.html",
    styleUrls: ["./ng-upload.component.less"]
})
export class NgUploadComponent {

    @Input() mediaAsset: ITCIMediaAsset;

    @Input() autoplay: boolean;

    @Input() displaySize: TCIMediaDisplaySize;

    @Input() mode: TCI_MEDIA_DISPLAY_MODE;

    @Input() refUrl: string;

    @Input() cssClasses: string | string[] = [];

    constructor() {
    }
}
